'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = ['#00D8A0', '#00ADC2', '#00C4B4', '#CF19E5', '#FF00AB', '#FF4E76'];